import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '../../components/AuthContext/context';
import { isAdmin } from '../../permissions/validators';
import { OrganizationDetailsSection } from './sections/OrganizationDetailsSection';

export const SettingsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { session } = useAuth();

  const { first_name, last_name, email, role, account, created_date, id } = session || {};
  const isAllowed = isAdmin(session);

  const actions = useMemo(
    (): ActionButtonProps[] => [
      {
        color: 'default',
        'data-test': 'user-edit-action-button',
        label: t('Edit User Details'),
        onClick: () => {
          navigate({ pathname: `/users/${id}/edit` }, { state: { settingsGoBackPath: '/settings' } });
        },
        showAsActionButton: true,
      },
      {
        color: 'default',
        'data-test': 'organizations-edit-action-button',
        label: t('Edit Organization Details'),
        onClick: () => {
          navigate({ pathname: `/organizations/${account?.id}/edit` }, { state: { settingsGoBackPath: '/settings' } });
        },
        showAsActionButton: true,
      },
    ],
    [navigate, account, id, t]
  );

  return (
    <PageHeader
      render={() => <HeaderActions actions={isAllowed ? actions : []} />}
      title={t('Settings')}
      titlePrefix={'OpenXSelect'}
    >
      <FormSection divider title={t('User Details')}>
        <FieldDetails title={t('First Name')} value={first_name} />
        <FieldDetails title={t('Last Name')} value={last_name} />
        <FieldDetails title={t('Email')} value={email} />
        <FieldDetails title={t('Roles')} value={role} />
        <FieldDetails title={t('Organization')} value={account?.name} />
        <FieldDetails title={t('Organization ID')} value={account?.id} />
        <FieldDetails title={t('Date Joined')} value={created_date} dateFormat="yyyy-MM-dd" showOffset={false} />
      </FormSection>

      <OrganizationDetailsSection accountId={account?.id} />
    </PageHeader>
  );
};
